import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import { casinoTabs } from "../../lib/data";
import CasinoCard from "./CasinoCard";
import MatchInfoSlider from "./MatchInfoBox";
import MainSlider from "../../containers/MainSlider";
import LeftBarSports from "./LeftBarSports.js";

import Teenpatti from "../../assets/images/popular/TeenPatti1.webp";
import JetX from "../../assets/images/popular/JetX1.webp";
import aviator from "../../assets/images/popular/Aviator1.webp";
import Andarbahar from "../../assets/images/popular/AndarBahar1.webp";
import Cards from "../../assets/images/popular/32Cards1.webp";
import DragonTiger from "../../assets/images/popular/DragonTiger1.webp";
import italianroulette from "../../assets/images/popular/ItalianRoulette1.webp";
// import Monopoly from "../../assets/images/popular/Monopolylive.webp";
import Lucky7 from "../../assets/images/popular/Lucky71.webp";
import SpeedRoulette from "../../assets/images/popular/AutoSpeedRoulette1.webp";
// import { sportsSocket } from "../../utils/socketUtil";
import { useDispatch } from "react-redux";
import { getBanners } from "../../redux/app/actions.js";
import ExchangeLobbyPage, {
  PAGE_LOAD_TYPE,
} from "../pages/privatePages/exchange/ExchangeLobbyPage.js";
import {
  APP_CONST,
  BANNER_CACHE_KEY,
  BANNER_CACHE_TIME,
} from "../../config/const.js";
import ModalWrapper from "../../containers/ModalWrapper.js";

import GamesProviderSection from "./GamesProviderSection.js";
import { casinoGamesList } from "../../lib/data/casinoGames.data.js";
import Footer from "../../containers/Footer.js";
import BeforeLoginFooter from "../../containers/BeforeLoginFooter.js";
import AtlasLobby, {
  COMPONENT_LOAD_TYPE,
} from "../pages/privatePages/sportsBook/atlasLobby.js";
import CasinoGamesListing from "../pages/privatePages/casino/index.js";
import Whatsapp from "../../assets/images/icons/whatsapp-new.png";
import AppDownload from "../../assets/images/icons/social.png";

import Teenpatti2020 from "../../assets/images/live-casino/teenpatti20201.jpg";
import DreamCatcher from "../../assets/images/live-casino/dreamctacher1.jpg";
import CashorCrash from "../../assets/images/live-casino/cashorcrash1.jpg";
import Trio from "../../assets/images/live-casino/trio1.jpg";
import Lottery from "../../assets/images/live-casino/lottery1.jpg";
import FootballStudio from "../../assets/images/live-casino/footballstudio1.jpg";
import CrazyTime from "../../assets/images/live-casino/crazytime1.jpg";
import BacBo from "../../assets/images/live-casino/bacbo1.jpg";
import Blackjack from "../../assets/images/live-casino/blackjack1.jpg";
import LightningRoulette from "../../assets/images/live-casino/lightningroulette1.jpg";
import UltimagteRoulette from "../../assets/images/live-casino/ultimateroulette1.jpg";

import Roulette from "../../assets/images/hot-games/Roulettes.webp";
import RockPaperScissors from "../../assets/images/hot-games/Rock-Paper-Scissors.webp";
import Plinko from "../../assets/images/hot-games/Plinkos.webp";
import Limbo from "../../assets/images/hot-games/Limbos.webp";
import Mines from "../../assets/images/hot-games/Mine.webp";
import FortuneGems from "../../assets/images/hot-games/Fortune-Gems.webp";
import Dice from "../../assets/images/hot-games/Dices.webp";
import Diamond from "../../assets/images/hot-games/Diamonds.webp";
import CockFight from "../../assets/images/hot-games/Cock-Fight.webp";
import ColorPrediction from "../../assets/images/hot-games/Color-Prediction.webp";

import Banner1 from "../../assets/images/banner/home/Banner1.jpg";
import Banner2 from "../../assets/images/banner/home/banner2.jpg";
import Banner3 from "../../assets/images/banner/home/banner3.jpg";
import Banner4 from "../../assets/images/banner/home/banner4.jpg";
import Banner5 from "../../assets/images/banner/home/banner5.jpg";
import Banner6 from "../../assets/images/banner/home/banner6.jpg";

import Funnoffers from "../../assets/images/banner/home/funnoffers.webp";
import JackpotWiners from "../../assets/images/banner/home/jackpotwinners.webp";
import Funnevents from "../../assets/images/banner/home/funnevents.webp";
import FunnVIP from "../../assets/images/banner/home/vipbanner.jpg";

const settings = {
  dots: false,
  arrows: true,
  autoplay: true,
  infinite: true,
  speed: 3000,
  slidesToShow: 7,
  slidesToScroll: 7,
  responsive: [
    {
      breakpoint: 1399,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
};

const settings1 = {
  dots: false,
  arrows: true,
  autoplay: true,
  infinite: true,
  speed: 2000,
  slidesToShow: 7,
  slidesToScroll: 7,
  responsive: [
    {
      breakpoint: 1399,
      settings: {
        slidesToShow: 7,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
};

const StaticBannersetting = {
  dots: false,
  arrows: false,
  autoplay: true,
  infinite: true,
  speed: 3000,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1399,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export const sliderGames = [
  {
    id: 1,
    name: "Teen Patti",
    img: Teenpatti,
    href: "/casino/ezugi/TeenPatti01",
  },
  {
    id: 2,
    name: "Aviator",
    img: aviator,
    href: "/casino/spribe/aviator",
  },
  {
    id: 3,
    name: "JetX",
    img: JetX,
    href: "/casino/aggapsmartsoftgaming-jetx",
  },
  {
    id: 4,
    name: "Andar Bahar",
    img: Andarbahar,
    href: "/casino/ezugi/AndarBaharLive",
  },
  {
    id: 5,
    name: "32 Cards",
    img: Cards,
    href: "/casino/ezugi/thirtytwoCards",
  },
  {
    id: 6,
    name: "Dragon Tiger",
    img: DragonTiger,
    href: "/casino/ezg-dragon-tiger",
  },
  {
    id: 7,
    name: "Italian Roulette",
    img: italianroulette,
    href: "/casino/ezugi/ItalianRoulette",
  },
  {
    id: 8,
    name: "Lucky 7",
    img: Lucky7,
    href: "/casino/ezugi/sevenLucky",
  },
  {
    id: 9,
    name: "Speed Roulette",
    img: SpeedRoulette,
    href: "/casino/ezugi/SpeedRoulette",
  },
];

export const livecasinoGames = [
  {
    id: 1,
    name: "Blackjack",
    img: Blackjack,
    href: "/casino/ezg-blackjack-1",
  },
  {
    id: 2,
    name: "Lightning Roulette",
    img: LightningRoulette,
    href: "/casino/ezgevo-lightning-roulette",
  },
  {
    id: 3,
    name: "Ultimate Roulette",
    img: UltimagteRoulette,
    href: "/casino/ezg-ultimate-roulette",
  },
  {
    id: 4,
    name: "Bac Bo",
    img: BacBo,
    href: "/casino/ezgevo-bac-bo",
  },
  {
    id: 5,
    name: "Crazy Time",
    img: CrazyTime,
    href: "/casino/ezgevo-crazy-time",
  },
  {
    id: 6,
    name: "Football studio",
    img: FootballStudio,
    href: "/casino/ezgevo-football-studio",
  },
  {
    id: 7,
    name: "Lottery",
    img: Lottery,
    href: "/casino/aggaproyalgaming-lottery-u8365",
  },
  {
    id: 8,
    name: "Trio",
    img: Trio,
    href: "/casino/aggaproyalgaming-trio",
  },
  {
    id: 9,
    name: "Cash or Crash",
    img: CashorCrash,
    href: "/casino/ezgevo-cash-or-crash",
  },
  {
    id: 10,
    name: "Dream Catcher",
    img: DreamCatcher,
    href: "/casino/ezgevo-dream-catcher",
  },
  {
    id: 11,
    name: "Teen Patti 20 20",
    img: Teenpatti2020,
    href: "/casino/aggapmac88gaming-20-20-teenpatti",
  },
];

export const hotGames = [
  {
    id: 1,
    name: "Cock Fight PHI",
    img: CockFight,
    href: "/casino/awc-cock-fight-phi",
  },
  {
    id: 2,
    name: "Color Prediction",
    img: ColorPrediction,
    href: "/casino/aggapjiligaming-color-prediction",
  },
  {
    id: 3,
    name: "Diamond",
    img: Diamond,
    href: "/casino/aggapmac88gamingvirtual-diamonds",
  },
  {
    id: 4,
    name: "Dice",
    img: Dice,
    href: "/casino/aggappopok-dice",
  },
  {
    id: 5,
    name: "Fortune Gems",
    img: FortuneGems,
    href: "/casino/aggaprich88-fortune-gems",
  },
  {
    id: 6,
    name: "Limbo",
    img: Limbo,
    href: "/casino/aggapjiligaming-limbo",
  },
  {
    id: 7,
    name: "Mines",
    img: Mines,
    href: "/casino/spribe/mines",
  },
  {
    id: 8,
    name: "Plinko",
    img: Plinko,
    href: "/casino/spribe/plinko",
  },
  {
    id: 9,
    name: "Rock Paper Scissors",
    img: RockPaperScissors,
    href: "/casino/aura-rock-paper-scissors",
  },
  {
    id: 10,
    name: "Roulette",
    img: Roulette,
    href: "/casino/ezg-italian-roulette",
  },
];

const PROVIDERS = [
  {
    id: 0,
    name: "Ezugi",
    key: "ezugi",
    redirectLastItem: "/casino/ezugi",
  },
  {
    id: 1,
    name: "Evolution",
    key: "evolution",
    redirectLastItem: "/casino/evolution",
  },
  {
    id: 2,
    name: "World Casino",
    key: "worldcasino",
    redirectLastItem: "/casino/worldcasino",
  },
  {
    id: 4,
    name: "Supernowa",
    key: "supernowa",
    redirectLastItem: "/casino/supernowa",
  },
  {
    id: 5,
    name: "NetEnt",
    key: "netent",
    redirectLastItem: "/netent",
  },
  {
    id: 6,
    name: "RedTiger",
    key: "redtiger",
    redirectLastItem: "/redtiger",
  },
  {
    id: 7,
    name: "Spribe",
    key: "spribe",
    redirectLastItem: "/Spribe",
  },
  {
    id: 8,
    name: "Kingmaker",
    key: "kingmaker",
    redirectLastItem: "/kingmaker",
  },
  {
    id: 9,
    name: "XPG",
    key: "xpg",
    redirectLastItem: "/casino/xpg",
  },
  {
    id: 10,
    name: "Vivo",
    key: "vivo",
    redirectLastItem: "/casino/vivo",
  },
  {
    id: 11,
    name: "Qtech",
    key: "qtech",
    redirectLastItem: "/casino/qtech",
  },
  // {
  //   id: 7,
  //   name: "Aura",
  //   key: "aura",
  // },
  // {
  //   id: 6,
  //   name: "Venum",
  //   key: "venum",
  // },
];
const RenderHomePageContent = () => {
  const { appDetails } = useSelector((state) => state.app);

  const { isAuth } = useSelector((state) => state.auth);
  const { banners } = useSelector((state) => state.app);
  const { sportsData } = useSelector((state) => state.sports);
  const dispatch = useDispatch();
  const [showAuthModals, setShowAuthModals] = useState(false);
  const [defaultModal, setDefaultModal] = useState(APP_CONST.AUTH_MODAL.LOGIN);
  const [casinoGamesArray, setCasinoGamesArray] = useState([]);
  const width = window.screen.width;
  const isMobile = width < 800;

  useEffect(() => {
    loadBannersWithCache();

    setCasinoGamesArray(getFormattedData(casinoGamesList));
  }, []);

  const loadBannersWithCache = async () => {
    const cachedData =
      sessionStorage.getItem(BANNER_CACHE_KEY) &&
      JSON.parse(sessionStorage.getItem(BANNER_CACHE_KEY));

    if (cachedData && Date.now() - cachedData?.saveTime <= BANNER_CACHE_TIME) {
      return;
    }

    const response = await dispatch(getBanners());

    if (response?.data) {
      sessionStorage.setItem(
        BANNER_CACHE_KEY,
        JSON.stringify({
          saveTime: Date.now(),
        })
      );
    }
  };

  const getFormattedData = (dataToFormat) => {
    let formattedGames = [];
    for (let key in dataToFormat) {
      Object.values(dataToFormat[key]).map((data) => {
        formattedGames.push(data);
      });
    }
    return formattedGames;
  };

  return (
    <main className="main">
      <div className="main-page">
        <LeftBarSports />

        <div className="main-content">
          <Container fluid>
            <div className="top_banner_sec mt-3 mb-1">
              <Row>
                <Col lg={12}>
                  <div className="mainBanner">
                    <MainSlider banners={banners} />
                  </div>
                </Col>
              </Row>
            </div>

            <div className="match_slider_sec">
              <Row>
                <Col xs={12}>
                  <MatchInfoSlider sportsData={sportsData} />
                </Col>
              </Row>
            </div>

            <div className="popular_game_sec d-none">
              <h1 className="head-popular">Funn777 Popular Games</h1>
              <Slider {...settings}>
                {sliderGames.map((item) => {
                  return (
                    <div>
                      <div className="game_box">
                        <a href={item?.href}>
                          <img
                            src={item?.img}
                            alt={item?.name}
                            className="popular-img"
                            height={118}
                          />
                        </a>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </div>

            <div className="OtherStaticBanner">
              {/* <h1 className="head-popular"> Available Offers</h1> */}
              <Slider {...StaticBannersetting}>
                <div>
                  <img src={Banner1} alt="Banner1" />
                </div>
                <div>
                  <img src={Banner2} alt="Banner2" />
                </div>
                <div>
                  <img src={Banner3} alt="Banner3" />
                </div>
                <div>
                  <a href="/casino/aggapjiligaming-color-prediction">
                    <img src={Banner4} alt="Banner4" />
                  </a>
                </div>
                <div>
                  <img src={Banner5} alt="Banner5" />
                </div>
                <div>
                  <img src={Banner6} alt="Banner6" />
                </div>
              </Slider>
            </div>

            <div className="Funn777Offers d-md-block d-none">
              {/* <h1 className="head-popular font-21">Funn777 Events</h1> */}
              <Slider {...StaticBannersetting}>
                <div>
                  <a href="/offers">
                    <img src={Funnoffers} alt="Funnoffers" />
                  </a>
                </div>
                <div>
                  <a href="/jackpots">
                    <img src={JackpotWiners} alt="Funnoffers" />
                  </a>
                </div>
                <div>
                  <a href="/vip">
                    <img src={FunnVIP} alt="Funnoffers" />
                  </a>
                </div>
                <div>
                  <a href="">
                    <img src={Funnevents} alt="Funnoffers" />
                  </a>
                </div>
              </Slider>
            </div>
            <div className="Funn777Offers d-md-none d-block">
              {/* <h1 className="head-popular font-21">Funn777 Events</h1> */}
              <Slider {...StaticBannersetting}>
                <div>
                  <a href="/offers">
                    <img src={Funnoffers} alt="Funnoffers" />
                  </a>
                </div>
                <div>
                  <a href="/jackpots">
                    <img src={JackpotWiners} alt="Funnoffers" />
                  </a>
                </div>
                <div>
                  <a href="/vip">
                    <img src={FunnVIP} alt="Funnoffers" />
                  </a>
                </div>
                <div>
                  <a href="">
                    <img src={Funnevents} alt="Funnoffers" />
                  </a>
                </div>
              </Slider>
            </div>

            <div className="popular_game_sec">
              <h1 className="head-popular"> Funn777 Games</h1>
              <Slider {...settings}>
                {hotGames.map((item) => {
                  return (
                    <div>
                      <div className="game_box">
                        <a href={item?.href}>
                          <img
                            src={item?.img}
                            alt={item?.name}
                            className="popular-img"
                            height={118}
                          />
                        </a>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </div>

            <div className="popular_game_sec">
              <h1 className="head-popular"> Live Casino</h1>
              <Slider {...settings}>
                {livecasinoGames.map((item) => {
                  return (
                    <div>
                      <div className="game_box">
                        <a href={item?.href}>
                          <img
                            src={item?.img}
                            alt={item?.name}
                            className="popular-img"
                            height={118}
                          />
                        </a>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </div>

            <div className="CasinoHomeSection d-none">
              <div className="d-flex align-items-center Casinoheading justify-content-between">
                <h1 className="head-popular">Funn777 Casino Games</h1>
                <a href="/casino/list">View All Games</a>
              </div>
              <div className="">
                <CasinoGamesListing />
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-between GameProviderSectionHeading">
              <h1 className="head-popular">Funn777 Game Providers</h1>
              <a href="/casino/list">View All Games</a>
            </div>

            <GamesProviderSection
              data={casinoGamesArray}
              providers={
                isMobile ? PROVIDERS.slice(0, 4) : PROVIDERS.slice(0, 6)
              }
              isMobile={isMobile}
              setShowAuthModals={setShowAuthModals}
            />

            <GamesProviderSection
              data={casinoGamesArray}
              providers={
                isMobile ? PROVIDERS.slice(4, 7) : PROVIDERS.slice(6, 11)
              }
              isMobile={isMobile}
              setShowAuthModals={setShowAuthModals}
            />
            {isMobile && (
              <GamesProviderSection
                data={casinoGamesArray}
                providers={PROVIDERS.slice(7, 11)}
                isMobile={isMobile}
                setShowAuthModals={setShowAuthModals}
              />
            )}

            <div className="popularSection popular_game_sec">
              <h1 className="head-popular">Game Providers</h1>
              <Slider {...settings1}>
                {Array.isArray(Object.values(casinoTabs?.providers)) &&
                  Object.values(casinoTabs?.providers)
                    .slice(0, 12)
                    .map((game, idx) => (
                      <CasinoCard
                        key={"casinogame" + idx}
                        data={game}
                        imgHeight={72}
                      />
                    ))}
              </Slider>
            </div>

            <div className="home-iframe">
              <div className="d-flex align-items-center justify-content-between">
                <h1 className="head-popular">Funn777 Live Sports</h1>
                <a href="/sports/Inplay">View Exchange</a>
              </div>

              <div className="beforelogin-iframe">
                <ExchangeLobbyPage
                  isAuth={isAuth}
                  loadType={COMPONENT_LOAD_TYPE.component}
                />
              </div>
            </div>
          </Container>

          {isAuth ? <Footer /> : <BeforeLoginFooter />}
        </div>
      </div>

      <div className="WhatsappSection d-none">
        <a
          className="panel"
          href={
            appDetails?.WHATS_APP_URL != ""
              ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
              : "javascript:void(0)"
          }
          target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
        >
          <img src={Whatsapp} alt="Whatsapp Icon" />
        </a>
      </div>

      {showAuthModals && (
        <ModalWrapper
          defaultShow={defaultModal}
          handleClose={setShowAuthModals}
        />
      )}
    </main>
  );
};
export default RenderHomePageContent;
